// src/pages/PaymentSuccess.jsx

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [paymentId, setPaymentId] = useState("");

  useEffect(() => {
    const paymentStatus = searchParams.get("status");
    const paymentId = searchParams.get("payment_id");

    if (paymentStatus && paymentId) {
      setPaymentId(paymentId);
      setStatus(paymentStatus);
    }
    setLoading(false);
  }, [searchParams]);

  return (
    <Container maxWidth="sm">
      <Box mt={8} textAlign="center">
        <Typography variant="h4" gutterBottom>
          Payment {status === "Credit" ? "Successful" : "Failed"}
        </Typography>

        {loading ? (
          <CircularProgress />
        ) : status === "Credit" ? (
          <Alert severity="success" sx={{ mt: 2 }}>
            Your payment was successful. Payment ID:{" "}
            <strong>{paymentId}</strong>
          </Alert>
        ) : (
          <Alert severity="error" sx={{ mt: 2 }}>
            Your payment failed. Please try again.
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default PaymentSuccess;
